import { types } from '../types/types'

const initialState = {
    movement: [],
}

export const movementReducer = (state = initialState, action) => {

    switch (action.type) {

        case types.movementLoaded:
            return {
                movement: [...action.payload]
            }

        default:
            return state;
    }
}

export default movementReducer;